import { commonParams } from "../endpoint/EndpointParameters";
import { de_FindOrderByShortOrderIdCommand, se_FindOrderByShortOrderIdCommand, } from "../protocols/Aws_restJson1";
import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class FindOrderByShortOrderIdCommand extends $Command.classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("TempeFabricationPublic", "FindOrderByShortOrderId", {})
    .n("TempeFabricationPublicClient", "FindOrderByShortOrderIdCommand").f(void 0, void 0)
    .ser(se_FindOrderByShortOrderIdCommand)
    .de(de_FindOrderByShortOrderIdCommand)
    .build() {
}
